import React, { useState } from "react"
import PropTypes from "prop-types"
import "./StaticField.scss"

const StaticField = ({ title, value, style = {}, titleStyle = {}, valueStyle = {}, url }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const shouldTruncate = !isExpanded && typeof value === "string" && value.length > 150
  const displayValue =
    value || value === 0 ? (typeof value === "number" ? value : shouldTruncate ? value.substring(0, 150) : value) : "-"

  return (
    <div
      className="static-field-container"
      style={style}
    >
      <div
        className="static-field-title"
        style={titleStyle}
      >
        {title}{" "}
      </div>
      <div
        className="static-field-value"
        style={valueStyle}
      >
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {displayValue}
          </a>
        ) : (
          displayValue
        )}
        {shouldTruncate && <span className="static-field-ellipsis">...</span>}
        {(shouldTruncate || isExpanded) && (
          <span
            className={`static-field-toggle ${isExpanded ? "collapse" : "expand"}`}
            onClick={handleToggleExpand}
          >
            {isExpanded ? "Collapse" : "Expand"}
          </span>
        )}
      </div>
    </div>
  )
}

StaticField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  titleStyle: PropTypes.object,
  valueStyle: PropTypes.object,
  url: PropTypes.string,
}

export default StaticField
